import { LazyAction, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { isFeatureEnabled } from 'owa-feature-flags';
const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "IRISService", webpackPrefetch: true */ './lazyIndex')
);
const lazyInitializePostIrisService = new LazyAction(lazyModule, m => m.postIRISService);
const lazyGetExperienceTypeForUser = new LazyAction(lazyModule, m => m.getExperienceTypeForUser);

runAfterInitialRender(() => {
    if (isFeatureEnabled('auth-realtimeEmail')) {
        lazyGetExperienceTypeForUser.importAndExecute().then(experienceType => {
            if (experienceType) {
                lazyInitializePostIrisService.importAndExecute(experienceType.toString());
            }
        });
    }
});
